import { OnboardingTypeEnum } from './customer.types';
import type { CustomerData } from './customer.types';

export const getCustomerModel = (): CustomerData => {
  return {
    didCompleteNonUSEDD: false,
    customerData: {
      onboardingTypeEnum: OnboardingTypeEnum.STANDARD,
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      cardFirstName: '',
      cardLastName: '',
      phoneNumber: '',
      phoneCountryCode: 'US',
      ssn: '',
      birthDate: '',
      idCountry: '',
      idNumber: '',
      idExpirationDate: '',
      idGovNumber: '',
      customerAddressData: {
        city: '',
        state: '',
        line1: '',
        line2: '',
        postalCode: '',
        country: '',
        sameAsPrimary: false,
      },
      customerBusinessData: {
        ownershipPercent: 100,
        segment: '',
        naicsIndustry: '',
        businessName: '',
        ein: '',
        incorporationState: '',
      },
      businessAddressData: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postalCode: '',
        sameAsPrimary: false,
      },
    },
  };
};
